/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { FunctionComponent } from 'react';
import withInjectedProps from '@atlassian/jira-common-util-with-injected-props/src/index.tsx';
import Breadcrumb from '../../breadcrumb/component.tsx';
import BoardBreadcrumb from '../../common-breadcrumbs/board/view.tsx';
import ProjectBreadcrumb from '../../common-breadcrumbs/project/index.tsx';
import UserBreadcrumb from '../../common-breadcrumbs/user/view.tsx';
import LegacyBreadcrumbConnector, { type LegacyBreadcrumbInjectedProps } from './component.tsx';
import ContextProvider from './context-provider/index.tsx';
import type { LegacyBreadcrumbConnectorProps } from './types.tsx';

const ExportedComponent: FunctionComponent<
	Omit<
		Omit<LegacyBreadcrumbConnectorProps & LegacyBreadcrumbInjectedProps, never> & Partial<unknown>,
		'legacyTrail' | keyof LegacyBreadcrumbInjectedProps
	>
> = withInjectedProps(LegacyBreadcrumbConnector, {
	Breadcrumb,
	ProjectBreadcrumb,
	// @ts-expect-error - TS2322 - Type '{ ({  children, boardId, boardName, isSimplifiedProject, projectId, }: BoardBreadcrumbProps): JSX.Element; defaultProps: { children: null; isSimplifiedProject: boolean; projectId: undefined; }; }' is not assignable to type 'ComponentType<Partial<BoardBreadcrumbProps>> | undefined'.
	BoardBreadcrumb,
	UserBreadcrumb,
	ContextProvider,
});
export default ExportedComponent;
